import {FormattedMessage} from "react-intl";
import sharedApiRequest from "../../services/apiRequest";
import {Fragment, useEffect, useState} from "react";

const CURRENT_YEAR = new Date().getFullYear();
const LINKS = [
  {
    labelId: "privacy_policy",
    labelDefault: "Privacy Policy",
    href: "https://www.kerakoll.com/privacy-policy/",
  },
  {
    labelId: "cookie_policy",
    labelDefault: "Cookie Policy",
    href: "https://www.kerakoll.com/cookie-policy/",
  },
  // {
  //   labelId: "sales_conditions",
  //   labelDefault: "Condizioni generali di vendita",
  //   href: "https://www.kerakoll.com/condizioni-generali-di-vendita/",
  // },
]

const VerticalRule = ({ h = "h-full" }) => <div className={`${h} border-l border-white`} />

export const PublicFooter = ({ className = "", showDeveloperLoginButton = true }) => {

  // state
  const [samlLoginUrl, setSamlLoginUrl] = useState<string>();

  // handlers
  useEffect(() => {
    // Fetch developer login redirect URL
    if (!showDeveloperLoginButton) return;
    sharedApiRequest.get("/saml/login", {publicRequest: true})
      .then((url) => setSamlLoginUrl(url as unknown as string));
  }, []);

  return (
    <div className={`w-full flex flex-col gap-5 py-7 px-4 sm:px-8 bg-black text-white text-xs ${className}`}>
      <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-row items-center gap-5">
          <img
            src={process.env.PUBLIC_URL + "/kerakoll-white.png"} alt="logo-kerakoll"
            className="w-24"
          />
          <VerticalRule h="h-10"/>
          <img
            src={process.env.PUBLIC_URL + "/ammagamma-small-white.png"} alt="logo-ammagamma"
            className="w-12"
          />
        </div>
        <div className="font-semibold">
          {LINKS.map(({labelId, labelDefault, href}, index) =>
            <Fragment key={index}>
              <a
                href={href}
                className="text-white hover:text-white hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id={labelId}
                  defaultMessage={labelDefault}
                />
              </a>
              {index < LINKS.length - 1 && <span className="mx-1">&mdash;</span>}
            </Fragment>
          )}
        </div>
      </div>
      <hr className="opacity-30" />
      <div className="leading-relaxed">
        Copyright &#169; {CURRENT_YEAR}
        &ndash;
        Kerakoll SpA
        &ndash;
        Società con unico socio Fin Firel Spa
        &ndash;
        Soggetta a direzione e coordinamento di Fin Firel Spa
        &ndash;
        Sede Legale Via dell’Artigianato 9, 41049 Sassuolo (MO) Italia
        &ndash;
        Numero Iscrizione Registro Imprese di Modena, P. Iva e Cod. Fisc. 01174510360
        &ndash;
        Capitale Sociale: Euro 2.000.000 i.v.
      </div>
      {showDeveloperLoginButton && !!samlLoginUrl && (
        <a
          href={samlLoginUrl}
          className={
            "border border-white text-white rounded hover:bg-white hover:text-black max-w-min px-2 py-1.5 pb-2 "
            + "whitespace-nowrap leading-none font-semibold cursor-pointer"
          }
        >
          Developer SSO
        </a>
      )}
    </div>
  )
}